import { type Ref, ref, watchEffect } from 'vue'
import type { ObjectInventoryTypeType } from './types.ts'
import { useLoadInventoryObjectTypes } from './api.ts'
import { defineStore } from 'pinia'
import type { InventoryFigure, InventoryLineType } from '@/entities/Inventory/Main'
import type { ObjectTypeTypeShort } from '@/entities/Manuals/ObjectTypes'

export const useInventoryObjectTypesModel = defineStore('inventory_object_types', () => {
  const figures = ref<InventoryFigure[]>([])
  const lines = ref<InventoryLineType[]>([])
  const objectTypes = ref<ObjectTypeTypeShort[]>([])

  const data = ref<ObjectInventoryTypeType[]>([])
  const total = ref<number>(0)

  /* Фильтры для таблицы */
  const filter = ref<{
    search: string
    object_type: number
    is_system?: number
    page: number
    per_page: number
  }>({
    search: '',
    object_type: 0,
    page: 1,
    per_page: 50,
  })

  /**
   * Функция загрузки данных
   */
  const loadData = (objectId: Ref<string>) => {
    const result = useLoadInventoryObjectTypes(filter, objectId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = result.data.value.data || []
        total.value = result.data.value.payload.total
        figures.value = result.data.value.payload.figures
        lines.value = result.data.value.payload.lines
        objectTypes.value = Array.isArray(result.data.value.payload.object_types)
          ? result.data.value.payload.object_types
          : []
      }
    })

    return result
  }

  /**
   * Функция очистки фильтра
   */
  const clearFilter = () => {
    filter.value = {
      ...filter.value,
      search: '',
      object_type: 0,
    }
  }

  return {
    data,
    filter,
    total,
    figures,
    lines,
    objectTypes,

    loadData,
    clearFilter,
  }
})
